// For some request and when we want to find rate by token symbol we need to get token name (e.x. USDC) from code (e.x. USDC_BNB)

export const getTokenNameFromCode = (code: string) => {
  return code.split("_")[0];
};
